import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sessionId) {
      navigate("/");
      return;
    }
    (async () => {
      try {
        const { data } = await api.get("/auth/session", {
          headers: { "X-Session-ID": sessionId },
        });
        setUser(data);
        window.history.replaceState(null, "", "/dashboard");
        if (data.role === "admin") navigate("/admin", { state: { user: data } });
        else if (data.role === "doctor") navigate("/doctor", { state: { user: data } });
        else if (data.role === "hospital") navigate("/hospital", { state: { user: data } });
        else navigate("/choose-role", { state: { user: data } });
      } catch {
        navigate("/");
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="w-8 h-8 animate-spin text-sky-600" />
        <p className="text-slate-600 font-medium">Signing you in to MedShift…</p>
      </div>
    </div>
  );
}
